window.addEventListener('scroll', function() {
  let scrollPosition = window.scrollY || window.pageYOffset;
  let documentHeight = document.documentElement.scrollHeight - window.innerHeight;
  let scrollPercentage = (scrollPosition / documentHeight) * 100;

  if (scrollPercentage > 5 && window._helpRepLoaded !== true) {
    // Load styles and scripts after user has scrolled more than 5%
    window._helpRepLoaded = true;

    // Load HelpRep
    var _a,vfP=null!==(_a=document.getElementById("vfHolder"))&&void 0!==_a?_a:document.head,vfS=document.createElement("script");vfS.setAttribute("src","https://d1o5e9vlirdalo.cloudfront.net/vfLoader.js");vfS.setAttribute("id","vfLoader");vfS.setAttribute("data-pk",encodeURIComponent("gosun"));vfS.setAttribute("data-e",encodeURIComponent("prod"));vfS.type="text/javascript";vfP&&vfP.appendChild(vfS);

    // Remove scroll event listener after loading
    window.removeEventListener('scroll', arguments.callee);
  }
});